module.exports = __webpack_public_path__ + "img/triangle-left.6ad30356.svg";